import * as React from 'react';

import { LinkTokenIntent } from '../../__generated__/globalTypes';

import { useAccountLink } from './useAccountLink';

interface IAddInvestmentAccountsFlowProps {
  bankConnectionId: string;
  /** The user added accounts, or backed out without adding any. */
  onDone: () => void;
  /** The session failed. Never arrives as `onDone` — the two outcomes are disjoint. */
  onError: () => void;
}

/**
 * Opens Plaid against one held connection as soon as it mounts, asking for the
 * account picker so the household can select the investment accounts its
 * original link left out. Renders nothing — mounting is the trigger, and every
 * outcome leaves through a callback.
 *
 * Mount it only for a connection that reports `canAddInvestments`; the server
 * refuses the session otherwise.
 */
const AddInvestmentAccountsFlow = ({ bankConnectionId, onDone, onError }: IAddInvestmentAccountsFlowProps) => {
  const { trigger, errorCode } = useAccountLink({
    bankConnectionId,
    intent: LinkTokenIntent.AddInvestments,
    onLinked: onDone,
    onCancelled: onDone,
  });

  React.useEffect(() => {
    trigger();
  }, [trigger]);

  // The skip-modal path has nowhere to show an error, so report it up.
  React.useEffect(() => {
    if (errorCode) {
      onError();
    }
  }, [errorCode, onError]);

  return null;
};

export default AddInvestmentAccountsFlow;
